import Select from 'components/Select';
import { comingFromOptions } from 'config';
import React from 'react';

const options = Object.entries(comingFromOptions).map(
  ([id, name]) => ({ id, name })
);

export default function ComingFromSelect({
  // * Props
  name, label
}) {
  return (
    <Select
      options={options}
      name={name}
      label={label}
    />
  );
}
